import React, { useContext, useState } from "react";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import TableHeadItem from "../../../../Helpers/Table/TableHeadItem";

const UpcomingTableHead = () => {
  const { Sort, setSort } = useContext(filtrationcontext);
  const [hoveredColumn, setHoveredColumn] = useState(null);
  const Sorting = (type) => {
    setSort((prevSort) => ({
      type: type,
      value: !prevSort.value,
    }));
  };
  return (
    <>
      <div className="table-head-container">
        <div className={`table-head d-flex p-16`}>
          <TableHeadItem
            title="Code"
            Sort={() => Sorting("code")}
            SortType={Sort.value}
            isHovered={hoveredColumn === "code"}
            onMouseEnter={() => setHoveredColumn("code")}
            onMouseLeave={() => setHoveredColumn(null)}
          />
          <TableHeadItem
            title="Vehicle"
            Sort={() => Sorting("vehicle")}
            SortType={Sort.value}
            isHovered={hoveredColumn === "vehicle"}
            onMouseEnter={() => setHoveredColumn("vehicle")}
            onMouseLeave={() => setHoveredColumn(null)}
          />
          <div className="fs-14 fw-400 text-capitalize table-element">
            Workshop Name
          </div>
          <div className="fs-14 fw-400 text-capitalize table-element">
            Status
          </div>
          <div className="fs-14 fw-400 text-capitalize table-element">
            Start Date
          </div>
          <div className="fs-14 fw-400 text-capitalize table-element">
            Estimation Date
          </div>
          <div className="fs-14 fw-400 text-capitalize table-element">
            Description
          </div>
          <div className="fs-14 fw-400 text-capitalize table-element">
            actions
          </div>
        </div>
      </div>
    </>
  );
};

export default UpcomingTableHead;
